import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import './payment-details-skeleton.scss';

export const PaymentDetailsSkeleton: React.FC = () => {
  return (
    <div className="payment-details-skeleton">
      {/* Upload Receipt */}
      <div className="upload-section">
        <Skeleton variant="rounded" height={50} />
      </div>

      {/* Parsed Payment Details */}
      <div className="parsed-details">
        {[...Array(7)].map((_, index) => (
          <div className="detail-row" key={index}>
            <Skeleton variant="text" width="30%" height={24} />
            <Skeleton variant="text" width="60%" height={30} />
          </div>
        ))}
      </div>
    </div>
  );
};
